<!-- Modificar el alo del header, 116px, logo de yoint mismo margin izquierdo, botones de 80px -->
<nav
  gaCategory="ga-demo-documents-header"
  class="navbar navbar-expand-xl navbar-light bg-light m-0 p-0 justify-content-end"
  [ngClass]="{ 'navbar-yoint': isIframe(), 'navbar-yoint-delete': !isIframe() }"
>
  <div class="container-fluid">
    <img
      (click)="ga4('demo-header-logo')"
      class="navbar-img"
      src="../../assets/images/LogoHeader.webp"
      alt=""
    />
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasNavbar"
      aria-controls="offcanvasNavbar"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="offcanvas offcanvas-end"
      tabindex="-1"
      id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel"
    >
      <div class="offcanvas-header">
        <img
          (click)="ga4('demo-header-logo')"
          class="navbar-img"
          src="../../assets/images/LogoHeader.webp"
          alt=""
        />
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <!-- <div class="offcanvas-body d-flex flex-column align-items-center justify-content-center"> -->
      <div
        class="offcanvas-body d-flex justify-content-xl-end flex-xl-row flex-column align-items-center justify-content-center justify-content-xl-end"
      >
        <!-- <ul class="navbar-nav mb-2 mb-lg-0 mr-3 text-center"> -->
        <ul class="navbar-nav mb-2 mb-lg-0 mr-3 d-flex align-items-center">
          <li
            (click)="toggle(i)"
            [ngClass]="{ 'nav-link active': item.active }"
            class="nav-item ml-3"
            *ngFor="let item of list; let i = index"
          >
            <a
              class="nav-link"
              routerLink="{{ item.link }}"
              (click)="openTab(i); ga4(item.event)"
              routerLinkActive="active"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              >{{ item.name }}</a
            >
          </li>
        </ul>

        <button
          (click)="openRegister(); ga4('demo-header-sign-up')"
          class="btn btn-primary m-0 pl-4 pr-4 my-2 my-sm-0 d-block m-auto d-xl-inline m-xl-0"
          type="submit"
        >
          Yoin On demand
        </button>
      </div>
    </div>
  </div>
</nav>
